
import React from "react";

import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Tag,
  Tooltip,
  message,
  Button,
  Avatar,
  Typography,
  Spin,
  Space,
  Result
} from "antd";

import {
  CheckCircleOutlined,
  SearchOutlined,
  FundViewOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
  LoadingOutlined,
  PlayCircleOutlined,
  SmileOutlined,
  DownloadOutlined,
  ArrowLeftOutlined
} from "@ant-design/icons";

import { getMlLists,metricDownload,fetchMetricFile,downloadEX } from "./../services";
import PdAutoComplete from "./../components/PdAutoComplete";
import PdRunSelect from "./../components/PdRunSelect";


const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 60,
    }}
    spin
  />
);


const data = [];

class MetricsModule extends React.Component {
  state = {
    usersList: [],
    currentUser: false,
    isLoader: false,
    userListState: [],
    currentMetric:false,
    selectedRuns:[],
    selectAll:false,
    metricBtn:false,
    metricSttus:false,
  };

  async componentDidMount() {
   
  }

  
  onSelect = (acValue,acOption) => {
      

      // console.log(acValue);
      // console.log(acOption);

      this.setState({
        currentMetric:acOption.element
      });
  }

  onSelectRuns = (acValue) => {

      acValue = acValue.map(item => item.key);
      

      this.setState({
        selectedRuns:acValue
      });
  }

  onSelectAll = (svalue) => {

    // console.log(svalue);

      this.setState({
        selectAll:svalue
      });
  }


 openMessage = (state) => {
  const key ="pd_metricl_loader"
  if(state){
    message.loading({
      content: 'Loading...',
      key,
    }, 3500);
  }

  if(!state){
    setTimeout(() => {

      this.setState({
        metricSttus : true,
      });

      message.success({
        content: 'File Ready to Download',
        key,
        duration: 2,
      });
    }, 2500);
  }
};
  
  resetData =  async(allData) => {

    this.setState({
    currentUser: false,
    userListState: [],
    currentMetric:false,
    selectedRuns:[],
    selectAll:false,
    metricBtn:false,
    metricSttus:false,
    })
  }

  syncData = async(allData) => {

    const thisReq = {};
      

    const {currentMetric,selectedRuns,selectAll} = this.state;

      thisReq.user = currentMetric;
      thisReq.select_all = selectAll;

      if(selectAll){
         
         thisReq.data = [];

      } else {
         let ids = allData.map(item=>item.key);
         thisReq.data = ids;
      }

      this.setState({
        isLoader:true
      });
      // console.log(thisReq);

      this.openMessage();

      const metricStatus = await metricDownload(thisReq);

      this.setState({
        isLoader:false
      });
      // console.log(metricStatus);

  }

  downloadMetric = async()=>{
    const {currentMetric}  = this.state;

    const {status,data} = await fetchMetricFile(currentMetric);

    if(status){
      // console.log(data);
      const skey = "pd_downloader"
     
      message.success({
        content: 'File Download Successfully.',
        skey,
        duration: 2,
      },3500);

      window.location.href = data;

    }

  }


  render() {
    const { usersList, currentMetric,selectedRuns, isLoader,metricSttus } = this.state;

    // console.log(currentMetric);

    return (
      <>
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title="ML Model List"
                extra={
                  (isLoader ? <Spin/ > : "")
                }
              >
                <Spin indicator={antIcon} spinning={isLoader}>
                  <div className="pdMetricsModule">
                   


                    <PdAutoComplete  acSelect={this.onSelect} />




                      { metricSttus ?  <Result
    icon={<SmileOutlined />}
    title="Great, we have done all the operations!"
    extra={[<Button onClick={this.downloadMetric} type="primary"> <DownloadOutlined /> Download Metrics</Button>,<Button
                    onClick={() => this.resetData()}
                    type="primary"
                    style={{
                      marginBottom: 16,
                    }}
                    icon={<ArrowLeftOutlined />}
                  >
                    Go Back
                  </Button>]}
  /> : (currentMetric && <PdRunSelect onSelectAllChild={this.onSelectAll} thisSync={this.syncData} selectChange={this.onSelectRuns}  user={currentMetric} />) }

                      

        
  
                   
                  </div>
                </Spin>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default MetricsModule;



